import { proxy } from 'valtio';

// this store is needed to share state between Login.tsx and Join.tsx
export default proxy({ email: '' });
